import React from 'react';
import { Formik, Field } from 'formik';

// components
import Input from 'components/Fields/Input';
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

interface FormValues {
  mediaspace_id: string;
}

interface Props {
  rawContent: string;
  onSubmit: (contentString: string) => void;
  formId: string;
  isReadOnly: boolean;
  closePanel: () => void;
}

const MediaspaceContent = ({ rawContent, onSubmit, formId, isReadOnly, closePanel }: Props) => {
  const initialValues: FormValues = {
    mediaspace_id: rawContent || '',
  };

  const handleSubmit = ({ mediaspace_id: contentString }: FormValues) => {
    onSubmit(contentString);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Field
              tag="text_input_mediaspace_id"
              name="mediaspace_id"
              label="Mediaspace ID"
              tooltip="Don't include https:// prefix in the field."
              placeholder="ex: 123456.mediaspace.kaltura.com"
              component={Input}
              disabled={isReadOnly}
            />
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default MediaspaceContent;
